import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Panel } from '@amzn/dvui/dist/Panel'
import { Text } from '@amzn/dvui/dist/Text'
import * as st from './heroQuickPromo.module.scss'
import * as cn from 'classnames'
import { AtfTreatmentProps } from '../../../reducers/features'
import { isTreatment } from '../../../utils/utils'

export interface IHeroQuickPromoProps extends AtfTreatmentProps {
  title?: WpsRuntime.atv.wps.DVString,
  content?: WpsRuntime.atv.wps.DVString
  image?: WpsRuntime.atv.wps.Image
}

export const HeroQuickPromo = ({ title, content, image, atfTreatment}: IHeroQuickPromoProps) =>
  (title || content) ? (
      <article className={cn(st.avHqlContainer, {['hqpContainer']: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}>
      <Panel className={cn('avu-clearfix', st.avHqpBanner, {[st.avHqpBannerRedesign]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}>
        {image && <HQPImageWithLink {...image}/>}
        <div>
          <header>
            <Text string={title} tag='small'/>
          </header>
          <p>
            <Text string={content} tag='small'/>
          </p>
        </div>
      </Panel>
    </article>
  ) : null

const HQPImageWithLink = ({ path, alt, link}: WpsRuntime.atv.wps.Image) =>
  path ? (
    link ? (
      <a href={link.href} aria-label={link.ariaLabel}>
        <HQPImage { ...{path, alt} } />
      </a>
    ) : (
      <HQPImage { ...{path, alt} } />
    )
  ) : null

interface HQPImageProps {
  path: string,
  alt?: string,
}

const HQPImage = ({ path, alt }: HQPImageProps) =>
  <div className={st.avUpsellImage}>
    <img src={path} alt={alt} />
  </div>
